var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.925,
    height: 10.331,
    viewBox: "0 0 17.925 10.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#100e12;stroke-linecap:round}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6256",
    "data-name": "Group 6256",
    transform: "translate(.5 .707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1478",
    "data-name": "Line 1478",
    className: "cls-1",
    transform: "translate(0 4.458)",
    d: "M0 0h16.718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1479",
    "data-name": "Line 1479",
    className: "cls-1",
    transform: "translate(12.26)",
    d: "m0 0 4.458 4.458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1480",
    "data-name": "Line 1480",
    className: "cls-1",
    transform: "translate(12.26 4.458)",
    d: "M0 4.458 4.458 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.1a43752b.svg";
export { ForwardRef as ReactComponent };